// Copyright (c) StrangeBee 2024

//import './wdyr'; //uncomment to enable log on entire app
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import CustomIntlProvider from '@Lang/';
import '@Lang/moment.i18n';
import { BrowserRouter as Router } from 'react-router-dom';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { QueryClientProvider } from 'react-query';
import { queryClient } from '@Client';
import { OrgSwitcherProvider } from '@Context/OrgSwitcherProvider';

import './index.css';
import 'antd/dist/antd.css';

export const baseUrl = window.document.querySelector('base')?.getAttribute('href') || '/';

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <CustomIntlProvider>
            <Router basename={baseUrl}>
                <DndProvider backend={HTML5Backend}>
                    <OrgSwitcherProvider>
                        <App />
                    </OrgSwitcherProvider>
                </DndProvider>
            </Router>
        </CustomIntlProvider>
    </QueryClientProvider>,
    document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
